<template>
  <template v-if="isAdm()">
    <div class="alert-default" role="alert">
      Esta é uma prévia de como o formulário de inscrição é apresentado aos
      alunos.
    </div>
    <div>
      <div class="validation-option">
        <input
          id="checkbox-validation"
          class="checkbox-default inverted"
          type="checkbox"
          v-model="validationEnabled"
        />
        <label for="checkbox-validation"> Habilitar validação </label>
      </div>
    </div>
    <hr/>
  </template>

  <div>
    <FormWizard
      ref="formWiz"
      backButtonText="Anterior"
      color="#5AAD31"
      finishButtonText="Finalizar"
      nextButtonText="Próximo"
      @on-complete="onComplete"
      @on-handle-tab-change="handleTabChange"
    >
      <!-- new tab content -->
      <!-- <navButtons class="nav-buttons"
      ><button class="fillButtonStyle" @click="prevTab">Voltar</button
      ><button class="btn" @click="nextTab">Avançar</button>
      </navButtons> -->

      <!-- DADOS PESSOAIS -->
      <TabContent
        :beforeChange="validatePersonalData"
        icon="fa fa-user"
        title="Dados pessoais"
      >
        <div class="card-body">
          <h6 class="card-title fw-bolder">Dados pessoais</h6>
          <p class="card-text">
            Este formulário é destinado a coletar informações pessoais dos
            usuários. Nele, será solicitado que o usuário preencha campos como
            nome completo, endereço, número de telefone, e-mail, data de
            nascimento e documentos de identificação, como CPF ou RG. Essas
            informações serão utilizadas para fins de contato, envio de
            informações e/ou para fins de verificação de identidade. É
            importante que as informações fornecidas sejam precisas e
            atualizadas, para garantir que possamos fornecer os serviços
            adequadamente. Observe que suas informações serão tratadas com
            confidencialidade e serão protegidas de acordo com as leis de
            privacidade aplicáveis.
          </p>

          <template
            v-if="
              enrollStatus === 5 &&
              fieldsPerSection.personalData.hasInconsistency
            "
          >
            <div class="inconsistent-notification">
              <hr />
              <span>
                <img alt="Revisar dados" src="../../assets/svg/warning.svg" />
                <p>
                  <strong>Revise os seguintes dados</strong> para dar
                  continuidade ao seu processo de inscrição:
                </p>
              </span>
              <ul class="inconsistent-items">
                <template
                  v-for="field in fieldsPerSection.personalData.fields"
                  :key="field"
                >
                  <li v-if="form[field].inconsistent === true">
                    {{ form[field].name }}
                  </li>
                </template>
              </ul>

              <span class="obs" v-if="form['observacao'] != null">
                <strong>Observação:</strong>
                <p>
                  {{ form.observacao }}
                </p>
              </span>
            </div>
          </template>

          <div class="mb-3">
            <label
              :class="{ red: form['nome'].inconsistent }"
              class="form-label"
              for="nome"
              >Nome completo</label
            >
            <!--:disabled="form['nome'].inconsistent === false"-->
            <input
              id="nome"
              v-model="form['nome'].value"
              v-maska="form.bindName"
              :class="{
                'is-invalid': v$.form.bindName.$error,
                'inconsistent-background': form['nome'].inconsistent,
              }"
              :disabled="true"
              class="form-control"
              data-maska="Z"
              data-maska-tokens="Z:[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]:multiple"
              name="nome"
              placeholder="Digite o nome e o sobrenome"
              type="text"
            />

            <div v-if="v$.form.bindName.$error" class="invalid-feedback">
              Por favor, preencha este campo corretamente.
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['nome_mae'].inconsistent }"
                  class="form-label"
                  for="nomeMae"
                  >Nome da mãe</label
                >

                <input
                  id="nomeMae"
                  v-model="form['nome_mae'].value"
                  v-maska="form.bindMothersName"
                  :class="{
                    'is-invalid': v$.form.bindMothersName.$error,
                    'inconsistent-background': form['nome_mae'].inconsistent,
                  }"
                  :disabled="form['nome_mae'].inconsistent === false"
                  class="form-control"
                  data-maska="Z"
                  data-maska-tokens="Z:[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]:multiple"
                  name="nomeMae"
                  placeholder="Digite o nome e o sobrenome"
                  type="text"
                />

                <div
                  v-if="v$.form.bindMothersName.$error"
                  class="invalid-feedback"
                >
                  Por favor, preencha este campo corretamente.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['nome_pai'].inconsistent }"
                  class="form-label"
                  for="nomePai"
                  >Nome do pai</label
                >

                <input
                  id="nomePai"
                  v-model="form['nome_pai'].value"
                  v-maska="form.bindFathersName"
                  :class="{
                    'is-invalid': v$.form.bindFathersName.$error,
                    'inconsistent-background': form['nome_pai'].inconsistent,
                  }"
                  :disabled="form['nome_pai'].inconsistent === false"
                  class="form-control"
                  data-maska="Z"
                  data-maska-tokens="Z:[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]:multiple"
                  name="nomePai"
                  placeholder="Digite o nome e o sobrenome"
                  type="text"
                />

                <div
                  v-if="v$.form.bindFathersName.$error"
                  class="invalid-feedback"
                >
                  Por favor, preencha este campo corretamente.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['cor'].inconsistent }"
                  class="form-label"
                  for="cor"
                  >Cor/raça</label
                >

                <select
                  v-model="form['cor'].value"
                  :class="{
                    'is-invalid': v$.form['cor'].value.$error,
                    'inconsistent-background': form['cor'].inconsistent,
                  }"
                  :disabled="form['cor'].inconsistent === false"
                  aria-label="Selecione sua cor"
                  class="form-select"
                  name="cor"
                >
                  <option selected value="">Selecione sua cor</option>
                  <option value="Preto">Preto</option>
                  <option value="Pardo">Pardo</option>
                  <option value="Branco">Branco</option>
                  <option value="Indígena">Indígena</option>
                  <option value="Amarelo">Amarelo</option>
                </select>

                <div
                  v-if="v$.form['cor'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione sua cor.
                </div>
              </div>
            </div>

            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['genero'].inconsistent }"
                  class="form-label"
                  for="genero"
                  >Gênero</label
                >

                <select
                  v-model="form['genero'].value"
                  :class="{
                    'is-invalid': v$.form['genero'].value.$error,
                    'inconsistent-background': form['genero'].inconsistent,
                  }"
                  :disabled="form['genero'].inconsistent === false"
                  aria-label="Selecione o seu gênero"
                  class="form-select"
                  name="genero"
                >
                  <option selected value="">Selecione o seu gênero</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Feminino">Feminino</option>
                </select>

                <div
                  v-if="v$.form['genero'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione um gênero.
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['cpf'].inconsistent }"
              class="form-label"
              for="cpf"
              >CPF</label
            >

            <input
              id="cpf"
              v-model="form['cpf'].value"
              v-maska="form.bindCPF"
              :class="{
                'is-invalid': v$.form.bindCPF.$error,
                'inconsistent-background': form['cpf'].inconsistent,
              }"
              :disabled="form['cpf'].inconsistent === false"
              class="form-control"
              data-maska="###.###.###-##"
              maxlength="14"
              name="CPF"
              placeholder="Digite o seu CPF"
              type="text"
              @keyup="checkCompleted()"
            />

            <div
              v-if="v$.form.bindCPF.$error || !cpfValidated"
              class="invalid-feedback"
            >
              Por favor, insira um CPF válido.
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['data_nascimento'].inconsistent }"
              class="form-label"
              for="dataNascimento"
              >Data de nascimento</label
            >

            <input
              id="dataNascimento"
              v-model="form['data_nascimento'].value"
              :class="{
                'is-invalid': v$.form['data_nascimento'].value.$error,
                'inconsistent-background': form['data_nascimento'].inconsistent,
              }"
              :disabled="form['data_nascimento'].inconsistent === false"
              class="form-control"
              name="dataNascimento"
              type="date"
            />

            <div
              v-if="v$.form['data_nascimento'].value.$error"
              class="invalid-feedback"
            >
              Por favor, preencha este campo corretamente.
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['contato'].inconsistent }"
              class="form-label"
              for="contato"
              >Contato</label
            >

            <input
              id="contato"
              v-model="form['contato'].value"
              v-maska="form.bindContact"
              :class="{
                'is-invalid': v$.form.bindContact.$error,
                'inconsistent-background': form['contato'].inconsistent,
              }"
              :disabled="form['contato'].inconsistent === false"
              class="form-control"
              data-maska="(##) #####-####"
              name="contato"
              placeholder="Digite o seu número de telefone"
              type="text"
            />

            <div v-if="v$.form.bindContact.$error" class="invalid-feedback">
              Por favor, preencha este campo corretamente. Ex.: (XX) 9XXXX-XXXX
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['orgao_emissor'].inconsistent }"
                  class="form-label"
                  for="orgaoEmissor"
                  >Órgão emissor</label
                >

                <VueMultiselect
                  v-model="form['orgao_emissor'].value"
                  :class="{
                    'is-invalid': v$.form['orgao_emissor'].value.$error,
                    'inconsistent-background':
                      form['orgao_emissor'].inconsistent,
                  }"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :custom-label="acronymWithNameIssBody"
                  :disabled="form['orgao_emissor'].inconsistent === false"
                  :options="orgaos_emissores"
                  deselectLabel=""
                  placeholder="Selecione um órgão emissor"
                  selectLabel=""
                  selectedLabel=""
                  showNoResults="true"
                />

                <p class="message-alert">
                  *Caso o órgão emissor não esteja na lista, selecione a opção
                  "Outro" ou "Órgão Estrangeiro".
                </p>

                <div
                  v-if="v$.form['orgao_emissor'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione um órgão emissor.
                </div>
              </div>
            </div>

            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['rg'].inconsistent }"
                  class="form-label"
                  for="registroGeral"
                  >RG</label
                >

                <input
                  id="registroGeral"
                  v-model="form['rg'].value"
                  v-maska="form.bindRG"
                  :class="{
                    'is-invalid': v$.form.bindRG.$error,
                    'inconsistent-background': form['rg'].inconsistent,
                  }"
                  :disabled="form['rg'].inconsistent === false"
                  class="form-control"
                  data-maska="Z"
                  data-maska-tokens="Z:[0-9a-zA-Z]:multiple"
                  name="registroGeral"
                  placeholder="Digite o seu RG"
                  type="text"
                />

                <div v-if="v$.form.bindRG.$error" class="invalid-feedback">
                  Por favor, preencha este campo corretamente.
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['orgao_emissor_uf'].inconsistent }"
              class="form-label"
              for="UFOrgaoEmissor"
              >UF</label
            >

            <select
              v-model="form['orgao_emissor_uf'].value"
              :class="{
                'is-invalid': v$.form['orgao_emissor_uf'].value.$error,
                'inconsistent-background':
                  form['orgao_emissor_uf'].inconsistent,
              }"
              :disabled="form['orgao_emissor_uf'].inconsistent === false"
              aria-label="Selecione a UF"
              class="form-select"
              name="UFOrgaoEmissor"
            >
              <option selected value="">Selecione a UF</option>
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espirito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MT">Mato Grosso</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>

            <div
              v-if="v$.form['orgao_emissor_uf'].value.$error"
              class="invalid-feedback"
            >
              Por favor, selecione um estado.
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['nacionalidade'].inconsistent }"
              class="form-label"
              >Nacionalidade</label
            >

            <div class="form-check">
              <input
                id="radioBtnNacionality2"
                v-model="form['nacionalidade'].value"
                :checked="form['nacionalidade'].value === 'Brasileira'"
                :disabled="form['nacionalidade'].inconsistent === false"
                class="form-check-input"
                name="nacionalidade"
                type="radio"
                value="Brasileira"
                @change="checkRadioButton"
              />

              <label class="form-check-label" for="radioBtnNacionality2">
                Brasileira
              </label>
            </div>

            <div class="form-check">
              <input
                id="radioBtnNacionality4"
                v-model="form['nacionalidade'].value"
                :checked="form['nacionalidade'].value === 'Cubana'"
                :disabled="form['nacionalidade'].inconsistent === false"
                class="form-check-input"
                name="nacionalidade"
                type="radio"
                value="Cubana"
                @change="checkRadioButton"
              />

              <label class="form-check-label" for="radioBtnNacionality4">
                Cubana
              </label>
            </div>

            <div class="group-input-check-text">
              <input
                id="radioBtnNacionality5"
                v-model="form['nacionalidade'].value"
                :checked="form['nacionalidade'].value === 'Outros'"
                :disabled="form['nacionalidade'].inconsistent === false"
                aria-label="Radio button for following text input"
                class="form-check-input mt-0"
                name="nacionalidade"
                type="radio"
                value="Outros"
                @change="checkRadioButton"
              />

              <input
                v-model="this.textInputNacionality"
                v-maska="form.bindNacionality"
                :class="{
                  'is-invalid':
                    v$.textInputNacionality.$error &&
                    !this.disabledRadioNacionality,
                }"
                :disabled="
                  disabledRadioNacionality ||
                  form['nacionalidade'].inconsistent === false
                "
                aria-label="Text input with radio button"
                class="form-control"
                data-maska="Z"
                data-maska-tokens="Z:[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]:multiple"
                placeholder="Outra nacionalidade"
                type="text"
              />
            </div>

            <div
              v-if="v$.form['nacionalidade'].value.$error"
              class="invalid-feedback"
            >
              Por favor, selecione alguma opção.
            </div>
            <div
              v-if="
                v$.textInputNacionality.$error && !this.disabledRadioNacionality
              "
              class="invalid-feedback"
            >
              Por favor, preencha o campo corretamente.
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['naturalidade_uf'].inconsistent }"
                  class="form-label"
                  for="UFNaturalidade"
                  >UF de naturalidade</label
                >
                <select
                  v-model="form['naturalidade_uf'].value"
                  :class="{
                    'is-invalid': v$.form['naturalidade_uf'].value.$error,
                    'inconsistent-background':
                      form['naturalidade_uf'].inconsistent,
                  }"
                  :disabled="
                    form['naturalidade_uf'].inconsistent === false ||
                    form['nacionalidade'].value !== 'Brasileira'
                  "
                  aria-label="Selecione a UF"
                  class="form-select"
                  name="UFNat"
                  @change="attCountiesPersonalData()"
                >
                  <option disabled selected value="Não selecionado">
                    Não selecionado
                  </option>
                  <option selected value="">Selecione um estado</option>

                  <option
                    v-for="statePersonalData in states"
                    :key="statePersonalData"
                    :value="statePersonalData.value"
                  >
                    {{ statePersonalData.text }}
                  </option>
                </select>
                <div
                  v-if="v$.form['naturalidade_uf'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione um estado.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['naturalidade_municipio'].inconsistent }"
                  class="form-label"
                  for="municipioNaturalidade"
                  >Município de naturalidade</label
                >
                <select
                  v-model="form['naturalidade_municipio'].value"
                  :class="{
                    'is-invalid':
                      v$.form['naturalidade_municipio'].value.$error,
                    'inconsistent-background':
                      form['naturalidade_municipio'].inconsistent,
                  }"
                  :disabled="
                    form['naturalidade_municipio'].inconsistent === false ||
                    !stateSelectedPersonalData
                  "
                  aria-label="Selecione o município"
                  class="form-select"
                  name="countyNat"
                >
                  <option disabled selected value="Não selecionado">
                    Não selecionado
                  </option>
                  <option selected value="">Selecione um município</option>
                  <option
                    v-for="countyPersonalData in countiesPersonalData"
                    :key="countyPersonalData"
                    :value="countyPersonalData"
                  >
                    {{ countyPersonalData }}
                  </option>
                </select>
                <div
                  v-if="v$.form['naturalidade_municipio'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione uma cidade.
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['nome_ies'].inconsistent }"
              class="form-label"
              for="ies"
              >Qual sua Instituição de Ensino Superior de Conclusão (IES) do
              Curso?</label
            >

            <p class="message-alert">
              *Caso sua instituição não esteja na lista, selecione a opção
              "Outras" ou "Estrangeira".
            </p>

            <VueMultiselect
              v-model="form['nome_ies'].value"
              :class="{
                'is-invalid': v$.form['nome_ies'].value.$error,
                'inconsistent-background': form['nome_ies'].inconsistent,
              }"
              :clear-on-select="false"
              :close-on-select="true"
              :custom-label="acronymWithNameIES"
              :disabled="form['nome_ies'].inconsistent === false"
              :options="universidades"
              deselectLabel=""
              placeholder="Selecione uma IES"
              selectLabel=""
              selectedLabel=""
              showNoResults="true"
            />

            <div
              v-if="v$.form['nome_ies'].value.$error"
              class="invalid-feedback"
            >
              Por favor, selecione uma IES.
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['data_conclusao_ies'].inconsistent }"
              class="form-label"
              for="dataConclusaoIES"
              >Ano de conclusão</label
            >

            <select
              v-model="form['data_conclusao_ies'].value"
              :class="{
                'is-invalid': v$.form['data_conclusao_ies'].value.$error,
                'inconsistent-background':
                  form['data_conclusao_ies'].inconsistent,
              }"
              :disabled="form['data_conclusao_ies'].inconsistent === false"
              aria-label="Selecione um ano de conclusão"
              class="form-select"
              name="dataConclusaoIES"
            >
              <option selected value="">Selecione um ano de conclusão</option>
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </select>

            <div
              v-if="v$.form['data_conclusao_ies'].value.$error"
              class="invalid-feedback"
            >
              Por favor, selecione um ano.
            </div>
          </div>
        </div>
      </TabContent>
      <!--  -->

      <!-- DOCUMENTOS -->
      <TabContent
        :beforeChange="validateDocuments"
        icon="fa fa-file"
        title="Documentos"
      >
        <div class="card-body">
          <h6 class="card-title fw-bolder">Documentos</h6>
          <p class="card-text">
            Para facilitar o processo, solicitamos que você envie apenas
            arquivos no formato <strong>PDF</strong>. Isso nos ajudará a
            garantir que possamos processar e visualizar os arquivos com
            eficiência.
          </p>

          <template
            v-if="
              enrollStatus === 5 && fieldsPerSection.documents.hasInconsistency
            "
          >
            <div class="inconsistent-notification">
              <hr />
              <span>
                <img src="../../assets/svg/warning.svg" />
                <p>
                  <strong>Revise os seguintes dados</strong> para dar
                  continuidade ao seu processo de inscrição:
                </p>
              </span>
              <ul class="inconsistent-items">
                <template
                  v-for="field in fieldsPerSection.documents.fields"
                  :key="field"
                >
                  <li v-if="form[field].inconsistent === true">
                    {{ form[field].name }}
                  </li>
                </template>
              </ul>

              <span class="obs" v-if="form['observacao'] != null">
                <strong>Observação:</strong>
                <p>
                  {{ form.observacao }}
                </p>
              </span>
            </div>
          </template>

          <div class="mb-3">
            <label
              :class="{ red: form['doc_identidade'].inconsistent }"
              class="mb-2"
              for="arquivoRG"
              style="color: #828282; font-size: 18px"
              >Carteira de identidade ou Registro Geral digitalizado
              <strong style="color: #dc3545">*Frente e verso</strong></label
            >

            <label class="w-100 label-file" for="file">
              <div class="text-center button-file">
                <img alt="Carregar arquivo" src="../../assets/svg/disk.svg" />
                <span>Escolher arquivo</span>
                <input
                  id="arquivoRG"
                  :disabled="form['doc_identidade'].inconsistent === false"
                  accept="application/pdf"
                  class="input-file"
                  name="docCarteiraIdentidade"
                  type="file"
                  @change="onFileSelected"
                />
              </div>
              <input
                :class="{
                  'is-invalid':
                    v$.form['doc_identidade'].value.$error ||
                    inputFiles['doc_identidade'].error,
                  'inconsistent-background':
                    form['doc_identidade'].inconsistent,
                }"
                :disabled="form['doc_identidade'].inconsistent === false"
                :placeholder="inputFiles['doc_identidade'].fileName"
                class="w-100 field-submit-file"
                readonly
              />
            </label>

            <p>
              *RG ou documento equivalente que contenha os dados completos
              contidos no RG, incluindo a naturalidade
              <strong>(A CNH não possui essa informação)</strong> – Documentação
              deve estar dentro da validade.
            </p>

            <div
              v-if="
                v$.form['doc_identidade'].value.$error ||
                inputFiles['doc_identidade'].error
              "
              class="invalid-feedback"
            >
              {{ inputFiles["doc_identidade"].message }}
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['doc_cpf'].inconsistent }"
              class="mb-2"
              for="arquivoCPF"
              style="color: #828282; font-size: 18px"
              >CPF digitalizado</label
            >
            <label class="w-100 label-file" for="file">
              <div class="text-center button-file">
                <img alt="Carregar arquivo" src="../../assets/svg/disk.svg" />
                <span>Escolher arquivo</span>
                <input
                  id="arquivoCPF"
                  :disabled="form['doc_cpf'].inconsistent === false"
                  accept="application/pdf"
                  class="input-file"
                  name="arquivoCPF"
                  type="file"
                  @change="onFileSelected"
                />
              </div>
              <input
                :class="{
                  'is-invalid':
                    v$.form['doc_cpf'].value.$error ||
                    inputFiles['doc_cpf'].error,
                  'inconsistent-background': form['doc_cpf'].inconsistent,
                }"
                :disabled="form['doc_cpf'].inconsistent === false"
                :placeholder="inputFiles['doc_cpf'].fileName"
                class="w-100 field-submit-file"
                readonly
              />
            </label>

            <div
              v-if="
                v$.form['doc_cpf'].value.$error || inputFiles['doc_cpf'].error
              "
              class="invalid-feedback"
            >
              {{ inputFiles["doc_cpf"].message }}
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['doc_diploma'].inconsistent }"
              class="mb-2"
              for="arquivoDiploma"
              style="color: #828282; font-size: 18px"
              >Diploma digitalizado
              <strong style="color: #dc3545">*Frente e verso</strong></label
            >
            <label class="w-100 label-file" for="file">
              <div class="text-center button-file">
                <img alt="Carregar arquivo" src="../../assets/svg/disk.svg" />
                <span>Escolher arquivo</span>
                <input
                  id="arquivoDiploma"
                  :disabled="form['doc_diploma'].inconsistent === false"
                  accept="application/pdf"
                  class="input-file"
                  name="arquivoDiploma"
                  type="file"
                  @change="onFileSelected"
                />
              </div>
              <input
                :class="{
                  'is-invalid':
                    v$.form['doc_diploma'].value.$error ||
                    inputFiles['doc_diploma'].error,
                  'inconsistent-background': form['doc_diploma'].inconsistent,
                }"
                :disabled="form['doc_diploma'].inconsistent === false"
                :placeholder="inputFiles['doc_diploma'].fileName"
                class="w-100 field-submit-file"
                readonly
              />
            </label>

            <div
              v-if="
                v$.form['doc_diploma'].value.$error ||
                inputFiles['doc_diploma'].error
              "
              class="invalid-feedback"
            >
              {{ inputFiles["doc_diploma"].message }}
            </div>
          </div>

          <div class="mb-3">
            <label
              :class="{ red: form['doc_certidao_casamento'].inconsistent }"
              class="mb-2"
              for="arquivoCertidaoCasamento"
              style="color: #828282; font-size: 18px"
              >Certidão de casamento (Opcional)</label
            >
            <label class="w-100 label-file" for="file">
              <div class="text-center button-file">
                <img alt="Carregar arquivo" src="../../assets/svg/disk.svg" />
                <span>Escolher arquivo</span>
                <input
                  id="arquivoCertidaoCasamento"
                  :disabled="
                    form['doc_certidao_casamento'].inconsistent === false &&
                    form['doc_certidao_casamento'].value != null
                  "
                  accept="application/pdf"
                  class="input-file"
                  name="arquivoCertidaoCasamento"
                  type="file"
                  @change="onFileSelected"
                />
              </div>
              <input
                :class="{
                  'is-invalid': inputFiles['doc_certidao_casamento'].error,
                  'inconsistent-background':
                    form['doc_certidao_casamento'].inconsistent,
                }"
                :disabled="
                  form['doc_certidao_casamento'].inconsistent === false &&
                  form['doc_certidao_casamento'].value != null
                "
                :placeholder="inputFiles['doc_certidao_casamento'].fileName"
                class="w-100 field-submit-file"
                readonly
              />
            </label>

            <div
              v-if="inputFiles['doc_certidao_casamento'].error"
              class="invalid-feedback"
            >
              {{ inputFiles["doc_certidao_casamento"].message }}
            </div>
          </div>
        </div>
      </TabContent>
      <!--  -->

      <!-- ENDEREÇO -->
      <TabContent
        :beforeChange="validateAddress"
        icon="fa fa-city"
        title="Endereço"
      >
        <div class="card-body">
          <h6 class="card-title fw-bolder">Informações de endereço</h6>
          <p class="card-text">
            Este formulário tem como objetivo coletar informações de endereço
            dos usuários. Nele, será solicitado que o usuário preencha campos
            como logradouro, número, complemento, bairro, cidade, estado e
            código postal. Essas informações serão utilizadas para fins de
            contato e/ou para fins de verificação de localização. É importante
            que as informações fornecidas sejam precisas e atualizadas para
            evitar erros na comunicação. Observe que suas informações serão
            tratadas com confidencialidade e serão protegidas de acordo com as
            leis de privacidade aplicáveis.
          </p>

          <template
            v-if="
              enrollStatus === 5 && fieldsPerSection.address.hasInconsistency
            "
          >
            <div class="inconsistent-notification">
              <hr />
              <span>
                <img src="../../assets/svg/warning.svg" />
                <p>
                  <strong>Revise os seguintes dados</strong> para dar
                  continuidade ao seu processo de inscrição:
                </p>
              </span>
              <ul class="inconsistent-items">
                <template
                  v-for="field in fieldsPerSection.address.fields"
                  :key="field"
                >
                  <li v-if="form[field].inconsistent === true">
                    {{ form[field].name }}
                  </li>
                </template>
              </ul>

              <span class="obs" v-if="form['observacao'] != null">
                <strong>Observação:</strong>
                <p>
                  {{ form.observacao }}
                </p>
              </span>
            </div>
          </template>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['cep'].inconsistent }"
                  class="form-label"
                  for="cep"
                  >CEP</label
                >
                <div class="input-group">
                  <input
                    id="cep"
                    v-model="form['cep'].value"
                    v-maska="form.bindCEP"
                    :class="{
                      'is-invalid': v$.form.bindCEP.$error,
                      'inconsistent-background': form['cep'].inconsistent,
                    }"
                    :disabled="form['cep'].inconsistent === false"
                    class="form-control"
                    data-maska="#####-###"
                    name="CEP"
                    placeholder="Digite o seu CEP"
                    type="text"
                    @keyup="checkCompletedCEP"
                  />
                  <button
                    :disabled="form['cep'].inconsistent === false"
                    class="btn btn-search"
                    type="button"
                    @click="openModalForSearchCEP"
                  >
                    <span>Buscar CEP</span>
                    <img src="../../assets/svg/lupa_action.svg" />
                  </button>
                  <div v-if="v$.form.bindCEP.$error" class="invalid-feedback">
                    Por favor, preencha este campo corretamente.
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['endereco'].inconsistent }"
                  class="form-label"
                  for="endereco"
                  >Endereço</label
                >
                <input
                  id="endereco"
                  v-model="form['endereco'].value"
                  :class="{
                    'is-invalid': v$.form['endereco'].value.$error,
                    'inconsistent-background': form['endereco'].inconsistent,
                  }"
                  :disabled="
                    form['endereco'].inconsistent === false ||
                    (cepFound && form['endereco'].found)
                  "
                  class="form-control"
                  name="endereco"
                  placeholder="Digite o seu endereço"
                  type="text"
                />
                <div
                  v-if="v$.form['endereco'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, preencha este campo corretamente.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['bairro'].inconsistent }"
                  class="form-label"
                  for="bairro"
                  >Bairro</label
                >
                <input
                  id="bairro"
                  v-model="form['bairro'].value"
                  :class="{
                    'is-invalid': v$.form['bairro'].value.$error,
                    'inconsistent-background': form['bairro'].inconsistent,
                  }"
                  :disabled="
                    form['bairro'].inconsistent === false ||
                    (cepFound && form['bairro'].found)
                  "
                  class="form-control"
                  name="bairro"
                  placeholder="Digite o seu bairro"
                  type="text"
                />
                <div
                  v-if="v$.form['bairro'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, preencha este campo corretamente.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['complemento'].inconsistent }"
                  class="form-label"
                  for="complemento"
                  >Complemento (opcional)</label
                >
                <input
                  id="complemento"
                  v-model="form['complemento'].value"
                  :disabled="
                    form['complemento'].inconsistent === false &&
                    form['complemento'].value == 'null'
                  "
                  class="form-control"
                  placeholder="Digite o seu complemento"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['endereco_uf'].inconsistent }"
                  class="form-label"
                  for="uf"
                  >UF</label
                >
                <select
                  v-model="form['endereco_uf'].value"
                  :class="{
                    'is-invalid': v$.form['endereco_uf'].value.$error,
                    'inconsistent-background': form['endereco_uf'].inconsistent,
                  }"
                  :disabled="
                    form['endereco_uf'].inconsistent === false || cepFound
                  "
                  aria-label="Selecione a UF"
                  class="form-select"
                  name="UFEndereco"
                  @change="attCountiesAddress()"
                >
                  <option selected value="">Selecione um estado</option>
                  <option
                    v-for="stateAddress in states"
                    :key="stateAddress"
                    :value="stateAddress.value"
                  >
                    {{ stateAddress.text }}
                  </option>
                </select>
                <div
                  v-if="v$.form['endereco_uf'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione um estado.
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <label
                  :class="{ red: form['municipio'].inconsistent }"
                  class="form-label"
                  for="municipio"
                  >Município</label
                >
                <select
                  v-model="form['municipio'].value"
                  :class="{
                    'is-invalid': v$.form['municipio'].value.$error,
                    'inconsistent-background': form['municipio'].inconsistent,
                  }"
                  :disabled="
                    form['municipio'].inconsistent === false ||
                    !stateSelectedAddress ||
                    cepFound
                  "
                  aria-label="Selecione o município"
                  class="form-select"
                  name="county"
                >
                  <option selected value="">Selecione um município</option>
                  <option
                    v-for="countyAddress in countiesAddress"
                    :key="countyAddress"
                    :value="countyAddress"
                  >
                    {{ countyAddress }}
                  </option>
                </select>
                <div
                  v-if="v$.form['municipio'].value.$error"
                  class="invalid-feedback"
                >
                  Por favor, selecione um município.
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabContent>
      <!--  -->
      <!-- <navButtonsTwo class="nav-buttons"><button @click="prevTab">Voltar</button><button @click="nextTab">{{props.isLastStep ? 'Concluir' : 'Avançar'}}/button></navButtonsTwo> -->

      <template #footer="props">
        <div class="wizard-footer-left">
          <button
            v-if="props.activeTabIndex > 0 || props.isLastStep"
            class="btn-default wizard-footer-left"
            @click="props.prevTab()"
          >
            Voltar
          </button>
        </div>
        <div class="wizard-footer-right">
          <button
            v-if="!props.isLastStep"
            class="btn-default wizard-footer-right"
            @click="props.nextTab()"
          >
            Avançar
          </button>

          <!-- <wizard-button v-else @click="onComplete" class="btn" :style="fillButtonStyle"> -->
          <button
            v-else
            class="btn-default"
            @click="props.nextTab()"
            :disabled="isAdm() && props.isLastStep"
          >
            {{ props.isLastStep ? "Concluir" : "Avançar" }}
          </button>
        </div>
      </template>
    </FormWizard>
  </div>

  <CEPModal />
  <SubmissionSentModal />
  <LoadingScreen :show="loadingScreen" />
</template>
<script>
import { FormWizard, TabContent } from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";
import { store } from "../../store/store";
import municipios from "../../assets/json/estados_municipios.json";
import universidades from "../../assets/json/universidades_br.json";
import orgaos_emissores from "../../assets/json/orgaos_emissores.json";
import { EnrollFormService, UserService } from "../../services";
import { useVuelidate } from "@vuelidate/core";
import { required, sameAs } from "@vuelidate/validators";
import CEPModal from "./CEPModal.vue";
import SubmissionSentModal from "./SubmissionSentModal.vue";
import LoadingScreen from "../LoadingScreen.vue";
import { Modal } from "bootstrap";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";

export default {
  components: {
    CEPModal,
    FormWizard,
    TabContent,
    SubmissionSentModal,
    LoadingScreen,
    VueMultiselect,
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      validationEnabled: true,
      roleUser: null,
      activeTabIndex: 0,
      fillButtonStyle: `
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 16px 48px;
        gap: 8px;
        width: 173px;
        height: 60px;
        background: #004A8A;
        border-radius: 10px;
        flex: none;
        order: 1;
        flex-grow: 0;
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF;
      `,
      loadingScreen: false,
      // Modal para realizar a busca pelo CEP
      searchCEPMmodal: null,
      // Modal de feedback
      submissionSentModal: null,
      // Status de inscrição do usuário
      enrollStatus: undefined,
      // JSON com a lista de todos os órgãos emissores
      orgaos_emissores,
      // JSON com a lista de todas as universidades brasileiras
      universidades,
      // JSON com a lista de todos os municípios brasileiros
      municipios,
      // Fonte do código + JSON (Select com todos os estados e cidades dinâmicas)
      // https://gist.github.com/nulldreams/098c113991d379d38c44bce4e4720221#file-brasil-json
      states: [
        { value: "AC", text: "Acre" },
        { value: "AL", text: "Alagoas" },
        { value: "AP", text: "Amapá" },
        { value: "AM", text: "Amazonas" },
        { value: "BA", text: "Bahia" },
        { value: "CE", text: "Ceará" },
        { value: "DF", text: "Distrito Federal" },
        { value: "ES", text: "Espírito Santo" },
        { value: "GO", text: "Goiás" },
        { value: "MA", text: "Maranhão" },
        { value: "MT", text: "Mato Grosso" },
        { value: "MS", text: "Mato Grosso do Sul" },
        { value: "MG", text: "Minas Gerais" },
        { value: "PA", text: "Pará" },
        { value: "PB", text: "Paraíba" },
        { value: "PR", text: "Paraná" },
        { value: "PE", text: "Pernambuco" },
        { value: "PI", text: "Piauí" },
        { value: "RJ", text: "Rio de Janeiro" },
        { value: "RN", text: "Rio Grande do Norte" },
        { value: "RS", text: "Rio Grande do Sul" },
        { value: "RO", text: "Rondônia" },
        { value: "RR", text: "Roraima" },
        { value: "SC", text: "Santa Catarina" },
        { value: "SP", text: "São Paulo" },
        { value: "SE", text: "Sergipe" },
        { value: "TO", text: "Tocantins" },
      ],

      countiesPersonalData: [],
      stateSelectedPersonalData: false,

      countiesAddress: [],
      stateSelectedAddress: false,

      years: [],

      fieldsPerSection: {
        personalData: {
          hasInconsistency: false,
          fields: [
            "nome",
            "nome_mae",
            "nome_pai",
            "cpf",
            "genero",
            "cor",
            "data_nascimento",
            "contato",
            "orgao_emissor",
            "rg",
            "orgao_emissor_uf",
            "nacionalidade",
            "naturalidade_uf",
            "naturalidade_municipio",
            "nome_ies",
            "data_conclusao_ies",
          ],
        },
        documents: {
          hasInconsistency: false,
          fields: [
            "doc_identidade",
            "doc_cpf",
            "doc_diploma",
            "doc_certidao_casamento",
          ],
        },
        address: {
          hasInconsistency: false,
          fields: [
            "cep",
            "endereco",
            "bairro",
            "complemento",
            "endereco_uf",
            "municipio",
          ],
        },
      },

      // Objeto que armazena os dados do formulário
      form: {
        userId: null,

        // Variáveis da seção de dados pessoais
        // Variáveis dos objetos maska
        bindName: {
          masked: "",
          unmasked: "teste",
          completed: false,
        },

        bindMothersName: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        bindFathersName: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        bindCPF: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        bindContact: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        bindRG: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        bindNacionality: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        // V-models dos inputs
        nome: {
          name: "Nome completo",
          value: "",
          inconsistent: undefined,
        },
        nome_mae: {
          name: "Nome da mãe",
          value: "",
          inconsistent: undefined,
        },
        nome_pai: {
          name: "Nome do pai",
          value: "",
          inconsistent: undefined,
        },
        genero: {
          name: "Gênero",
          value: "",
          inconsistent: undefined,
        },
        cor: {
          name: "Cor",
          value: "",
          inconsistent: undefined,
        },
        cpf: {
          name: "CPF",
          value: "",
          inconsistent: undefined,
        },
        data_nascimento: {
          name: "Data de nascimento",
          value: "",
          inconsistent: undefined,
        },
        contato: {
          name: "Contato",
          value: "",
          inconsistent: undefined,
        },
        orgao_emissor: {
          name: "Órgão emissor",
          value: "",
          inconsistent: undefined,
        },
        rg: {
          name: "RG",
          value: "",
          inconsistent: undefined,
        },
        orgao_emissor_uf: {
          name: "UF",
          value: "",
          inconsistent: undefined,
        },
        nacionalidade: {
          name: "Nacionalidade",
          value: "",
          inconsistent: undefined,
        },

        naturalidade_uf: {
          name: "UF de naturalidade",
          value: "",
          inconsistent: undefined,
        },

        naturalidade_municipio: {
          name: "Município de naturalidade",
          value: "",
          inconsistent: undefined,
        },

        nome_ies: {
          name: "IES",
          value: "",
          inconsistent: undefined,
        },

        data_conclusao_ies: {
          name: "Data de conclusão IES",
          value: "",
          inconsistent: undefined,
        },

        // Variáveis da seção documentos
        doc_identidade: {
          name: "Carteira de identidade ou Registro Geral digitalizado",
          value: null,
          inconsistent: undefined,
        },
        doc_cpf: {
          name: "CPF digitalizado",
          value: null,
          inconsistent: undefined,
        },
        doc_diploma: {
          name: "Diploma digitalizado",
          value: null,
          inconsistent: undefined,
        },
        doc_certidao_casamento: {
          name: "Certidão de casamento",
          value: null,
          inconsistent: undefined,
        },

        // Variáveis da seção endereço
        bindCEP: {
          masked: "",
          unmasked: "",
          completed: false,
        },

        cep: {
          name: "CEP",
          value: "",
          inconsistent: undefined,
        },

        endereco: {
          name: "Endereço",
          value: "",
          inconsistent: undefined,
          found: false,
        },

        bairro: {
          name: "Bairro",
          value: "",
          inconsistent: undefined,
          found: false,
        },

        complemento: {
          name: "Complemento",
          value: "",
          inconsistent: undefined,
        },

        endereco_uf: {
          name: "UF",
          value: "",
          inconsistent: undefined,
        },

        municipio: {
          name: "Município",
          value: "",
          inconsistent: undefined,
        },

        observacao: "",
      },

      // Guarda o estado da validação do CPF
      cpfValidated: " ",

      // Variável de controle que habilita/desabilita inputs de endereço de acordo com o retorno da API de CEP
      cepFound: false,

      // Variável de controle para habilitar/desabilitar input de nacionalidade
      disabledRadioNacionality: true,
      // Variável que guardará o valor final (seja ele selecionado nos radio buttons ou digitado no input text)
      nacionality: "",
      // Guarda o valor do input text nacionalidade (quando selecionado)
      textInputNacionality: "",

      // Objeto que guarda informações e estados dos inputs dos documentos
      inputFiles: {
        doc_identidade: {
          message: "Por favor, selecione um arquivo.",
          fileName: "Nome do arquivo",
          error: false,
        },
        doc_cpf: {
          message: "Por favor, selecione um arquivo.",
          fileName: "Nome do arquivo",
          error: false,
        },
        doc_diploma: {
          message: "Por favor, selecione um arquivo.",
          fileName: "Nome do arquivo",
          error: false,
        },
        doc_certidao_casamento: {
          message: "",
          fileName: "Nome do arquivo",
          error: false,
        },
      },
    };
  },

  async created() {
    this.loadingScreen = true;

    const user = UserService.getUser();

    // Pega o id do usuário logado ao iniciar a página
    this.form.userId = user.id;

    // Pega o papel do usuário
    this.roleUser = user.roles[0].nome;

    // Pega o status de inscrição do usuário logado ao iniciar a página
    this.enrollStatus = user.status_geral;

    // Array com os status que não devem ser permitir acesso ao formulário
    const status = [1, 3, 4, 6, 7, 8];

    // Se o status for diferente de "Não Enviado [2]" ou "Dados inválidos [5]" redireciona o usuário para a página inicial
    if (status.includes(this.enrollStatus)) {
      this.$router.push("/");
      return;
    }

    // Verifica se o status é igual a "Dados inválidos [5]"
    if (this.enrollStatus === 5) {
      // Lista de documentos
      let documents = [
        "doc_identidade",
        "doc_cpf",
        "doc_diploma",
        "doc_certidao_casamento",
      ];
      // Campos que não devem ser verificados no laço
      let hiddenFields = [
        "geral",
        "avaliador_id",
        "avaliador_data",
        "quant_revisoes",
        "created_at",
        "updated_at",
      ];

      // Laço para verificar os campos inconsistentes
      for (let status in user.status) {
        // Caso o campo não possa ser verificado, vai para a próxima iteração
        if (hiddenFields.includes(status)) {
          continue;
        }

        // Caso a iteração atual for o campo "observacao", usa o valor
        if (status === "observacao") {
          this.form["observacao"] = user.status["observacao"];
          continue;
        }

        // Caso o status do campo for igual a "Dados inválidos [5]", o campo será marcado como inconsistente
        // this.form[status].inconsistent = user.status[status] == 5;
        if (user.status[status] === 5) {
          this.form[status].inconsistent = true;
          // Verifica se existe algum campo inconsistente em uma determinada seção
          for (let section in this.fieldsPerSection) {
            if (
              this.fieldsPerSection[section].fields.includes(status) &&
              !this.fieldsPerSection[section].hasInconsistency
            ) {
              this.fieldsPerSection[section].hasInconsistency = true;
            }
          }
        } else {
          this.form[status].inconsistent = false;
        }
      }

      // Atualizando listas de municípios
      this.updateCountiesPersonalData(user.data.naturalidade_uf);
      this.updateCountiesAddress(user.data.endereco_uf);

      // Dados pessoais
      this.form["nome"].value = user.name;
      this.form["nome_mae"].value = user.data.nome_mae;
      this.form["nome_pai"].value = user.data.nome_pai;
      this.form["cor"].value = user.data.cor;
      this.form["genero"].value = user.data.genero;
      this.form["cpf"].value = user.data.cpf;
      this.form["data_nascimento"].value = user.data.data_nascimento;
      this.form["contato"].value = user.data.contato;
      this.form["orgao_emissor"].value = this.lookForObjectIssBody(
        user.data.orgao_emissor
      );
      this.form["rg"].value = user.data.rg;
      this.form["orgao_emissor_uf"].value = user.data.orgao_emissor_uf;

      if (
        user.data.nacionalidade === "Brasileira" ||
        user.data.nacionalidade === "Cubana"
      ) {
        this.form["nacionalidade"].value = user.data.nacionalidade;
      } else {
        this.form["nacionalidade"].value = "Outros";
        this.disabledRadioNacionality = false;
        this.textInputNacionality = user.data.nacionalidade;
      }

      this.form["naturalidade_uf"].value = user.data.naturalidade_uf;
      this.form["naturalidade_municipio"].value =
        user.data.naturalidade_municipio;
      this.form["nome_ies"].value = this.lookForObjectUniversity(
        user.data.nome_ies
      );
      this.form["data_conclusao_ies"].value = user.data.data_conclusao_ies;

      // Documentos
      for (let document of documents) {
        // this.inputFiles[document].fileName = user.data[document].local
        if (
          this.form[document].inconsistent == false &&
          user.data[document] != null
        ) {
          // Caso o documento não for marcado como inconsistente atribui qualquer valor para passar na validação e não permitir que o documento seja enviado
          this.form[document].value = "#";
          this.inputFiles[document].fileName = "Enviado";
        } else {
          this.inputFiles[document].fileName = "Nome do arquivo";
        }
      }

      // Endereço
      this.form["cep"].value = user.data.cep;
      this.form["endereco"].value = user.data.endereco;
      this.form["bairro"].value = user.data.bairro;

      this.form["complemento"].value = user.data.complemento;

      if (user.data.complemento == null || user.data.complemento == "null") {
        this.form["complemento"].value = "";
      } else {
        this.form["complemento"].value = user.data.complemento;
      }

      this.form["endereco_uf"].value = user.data.endereco_uf;
      this.form["municipio"].value = user.data.municipio;
    } else {
      // Caso seja o primeiro acesso do usuário
      // Dados pessoais
      this.form["nome"].value = user.name;
      this.form["nome_mae"].value = user.data.nome_mae;
      this.form["nome_pai"].value = user.data.nome_pai;
      this.form["cpf"].value = user.data.cpf;
      this.form["data_nascimento"].value = user.data.data_nascimento;
      this.form["contato"].value = user.data.contato;
      // this.form["orgao_emissor"].value = this.lookForObjectIssBody(user.data.orgao_emissor)
      this.form["rg"].value = user.data.rg;
      // this.form["orgao_emissor_uf"].value = user.data.orgao_emissor_uf
    }

    // Cria uma lista com todas as datas válidas para conclusão de curso
    let currentDate = new Date();
    for (let date = currentDate.getFullYear(); date >= 1900; date--) {
      this.years.push(date);
    }

    this.loadingScreen = false;
  },

  mounted() {
    this.$watch(
      () => this.$refs.formWiz.isLastStep,
      (newValue) => {
        store.isLastStep = newValue;
      }
    );
    this.$watch(
      () => this.$refs.formWiz.activeTabIndex,
      (newValue) => {
        store.isFirstStep = newValue === 0;
      }
    );

    this.searchCEPMmodal = new Modal(document.getElementById("searchCEPModal"));
    this.submissionSentModal = new Modal(
      document.getElementById("submissionSentModal")
    );
  },

  validations() {
    return {
      textInputNacionality: { required },

      form: {
        bindName: {
          masked: { required },
          unmasked: { required },
          completed: { required },
        },

        bindMothersName: {
          masked: { required },
          unmasked: { required },
          completed: { required },
        },

        bindFathersName: {
          masked: { required },
          unmasked: { required },
          completed: { required },
        },

        genero: {
          value: { required },
        },

        cor: {
          value: { required },
        },

        bindCPF: {
          masked: { required },
          unmasked: { required },
          completed: { sameAs: sameAs(true) },
        },

        data_nascimento: {
          value: { required },
        },

        bindContact: {
          masked: { required },
          unmasked: { required },
          completed: { sameAs: sameAs(true) },
        },

        orgao_emissor: {
          value: { required },
        },

        bindRG: {
          masked: { required },
          unmasked: { required },
          completed: { required },
        },

        orgao_emissor_uf: {
          value: { required },
        },

        nacionalidade: {
          value: { required },
        },

        bindNacionality: {
          masked: { required },
          unmasked: { required },
          completed: { required },
        },

        // state: { required },

        naturalidade_uf: {
          value: { required },
        },

        naturalidade_municipio: {
          value: { required },
        },

        nome_ies: {
          value: { required },
        },

        data_conclusao_ies: {
          value: { required },
        },

        // Variáveis da seção documentos
        doc_identidade: {
          value: { required },
        },
        doc_cpf: {
          value: { required },
        },
        doc_diploma: {
          value: { required },
        },

        // Variáveis da seção endereço
        bindCEP: {
          masked: { required },
          unmasked: { required },
          completed: { sameAs: sameAs(true) },
        },

        endereco: {
          value: { required },
        },

        bairro: {
          value: { required },
        },

        endereco_uf: {
          value: { required },
        },

        municipio: {
          value: { required },
        },
      },
    };
  },

  methods: {
    isAdm() {
      return this.roleUser === "Administrador (a)";
    },

    checkRadioButton() {
      // Caso a nacionalidade for diferente de Brasileira, os inputs de uf e municipio deverão ser desabilitados
      if (this.form["nacionalidade"].value !== "Brasileira") {
        this.form["naturalidade_uf"].value = "Não selecionado";
        this.form["naturalidade_municipio"].value = "Não selecionado";
        this.stateSelectedPersonalData = false;
      } else {
        this.form["naturalidade_uf"].value = "";
        this.form["naturalidade_municipio"].value = "";
      }

      if (this.form["nacionalidade"].value === "Outros") {
        // Habilita input do tipo texto
        this.disabledRadioNacionality = false;
      } else {
        // Desabilita input do tipo texto
        this.disabledRadioNacionality = true;
        // Limpa o input do tipo texto
        this.textInputNacionality = "";
      }
    },

    nextContent() {
      // Limpa as mensagens de erro
      this.v$.$reset();

      // Vai para o topo da página
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    async validatePersonalData() {
      if (!this.validationEnabled) {
        this.nextContent();
        return true;
      }

      // Valida todos os campos da seção de dados pessoais
      await this.v$.$validate();

      // Verifica se todos os campos estão válidos
      if (
        this.v$.form.bindName.masked.$invalid ||
        this.v$.form.bindMothersName.masked.$invalid ||
        this.v$.form.bindFathersName.masked.$invalid ||
        this.v$.form["genero"].value.$invalid ||
        this.v$.form["cor"].value.$invalid ||
        this.v$.form.bindCPF.masked.$invalid ||
        (this.v$.form.bindCPF.completed.$invalid && !this.cpfValidated) ||
        this.v$.form["data_nascimento"].value.$invalid ||
        this.v$.form.bindContact.masked.$invalid ||
        this.v$.form.bindContact.completed.$invalid ||
        this.v$.form["orgao_emissor"].value.$invalid ||
        this.v$.form.bindRG.masked.$invalid ||
        this.v$.form["orgao_emissor_uf"].value.$invalid ||
        this.v$.form["nacionalidade"].value.$invalid ||
        (this.v$.textInputNacionality.$invalid &&
          !this.disabledRadioNacionality) ||
        this.v$.form["naturalidade_uf"].value.$invalid ||
        this.v$.form["naturalidade_municipio"].value.$invalid ||
        this.v$.form["nome_ies"].value.$invalid ||
        this.v$.form["data_conclusao_ies"].value.$invalid
      ) {
        // Se algum campo estiver inválido, retorna false impedindo que o usuário passe para a próxima seção
        return false;
      } else {
        // Se todos os campos estiverem válidos, limpa as mensagens de erro atraés do $reset() e retorna true para levar o usuário para a próxima seção
        this.nextContent();
        return true;
      }
    },

    async validateDocuments() {
      if (!this.validationEnabled) {
        this.nextContent();
        return true;
      }

      await this.v$.$validate();

      if (
        this.v$.form["doc_identidade"].value.$invalid ||
        this.v$.form["doc_cpf"].value.$invalid ||
        this.v$.form["doc_diploma"].value.$invalid
      ) {
        return false;
      } else {
        this.nextContent();
        return true;
      }
    },

    async validateAddress() {
      await this.v$.$validate();

      if (
        this.v$.form.bindCEP.masked.$invalid ||
        this.v$.form.bindCEP.completed.$invalid ||
        this.v$.form["endereco"].value.$invalid ||
        this.v$.form["bairro"].value.$invalid ||
        this.v$.form["endereco_uf"].value.$invalid ||
        this.v$.form["municipio"].value.$invalid
      ) {
        return false;
      } else {
        this.nextContent();
        return true;
      }
    },

    // Função que é executada quando o formulário é enviado
    async onComplete() {
      // Ativa a tela de loading ao enviar o formulário
      this.loadingScreen = true;
      // Lista de documentos
      let documents = [
        "doc_identidade",
        "doc_cpf",
        "doc_diploma",
        "doc_certidao_casamento",
      ];

      const data = new FormData();

      // Verifica se o campo de nacionalidade do tipo texto foi habilitado para escrita
      if (this.disabledRadioNacionality === true) {
        // Caso não tenha sido habilitado, a nacionalidade é a selecionada no radio button
        this.nacionality = this.form["nacionalidade"].value;
      } else {
        // Caso tenha sido habilitado, a nacionalidade é a escrita no input do tipo texto
        this.nacionality = this.textInputNacionality;
      }

      // Variáveis da seção de dados pessoais
      data.append("nome", this.form.bindName.masked);
      data.append("nome_mae", this.form.bindMothersName.masked);
      data.append("nome_pai", this.form.bindFathersName.masked);
      data.append("genero", this.form.genero.value);
      data.append("cor", this.form.cor.value);
      data.append("cpf", this.form.bindCPF.unmasked);
      data.append("data_nascimento", this.form["data_nascimento"].value);
      data.append("contato", this.form.bindContact.unmasked);
      data.append("orgao_emissor", this.form["orgao_emissor"].value.extenso);
      data.append("rg", this.form.bindRG.masked);
      data.append("orgao_emissor_uf", this.form["orgao_emissor_uf"].value);
      data.append("nacionalidade", this.nacionality);
      data.append("naturalidade_uf", this.form["naturalidade_uf"].value);
      data.append(
        "naturalidade_municipio",
        this.form["naturalidade_municipio"].value
      );
      data.append("nome_ies", this.form["nome_ies"].value.universidade);
      data.append("data_conclusao_ies", this.form["data_conclusao_ies"].value);

      // Envio dos dados da seção documentos
      for (let document in documents) {
        let documentName = documents[document];

        // Verifica se o documento foi selecionado e se não foi marcado como inconsistente
        if (
          this.form[documentName].value != null &&
          this.form[documentName].value !== "#"
        ) {
          data.append(documentName, this.form[documentName].value);
        }
      }

      // Variáveis das seção endereço
      data.append("cep", this.form.bindCEP.unmasked);
      data.append("endereco", this.form["endereco"].value);
      data.append("bairro", this.form["bairro"].value);
      data.append("complemento", this.form["complemento"].value);
      data.append("endereco_uf", this.form["endereco_uf"].value);
      data.append("municipio", this.form["municipio"].value);

      let objectData = {
        userId: this.form.userId,
        form: data,
      };

      // Chamada do service para envio dos dados do formulário
      await EnrollFormService.sendStudentData(objectData).then(
        // Sucesso
        () => {
          // Notifica que o formulário foi submetido
          this.loadingScreen = false;
          this.submissionSentModal.show();
        },
        // Erro
        () => {
          // Retorna erro do servidor
          this.loadingScreen = false;
          alert("Ocorreu um erro. Tente novamente mais tarde.");
          this.$router.push("/");
        }
      );
    },

    onFileSelected(event) {
      // Armazena o id do input que foi selecionado
      let inputId = event.target.id;
      // Armazena o arquivo selecionado pelo usuário
      let fileSelected = event.target.files[0];
      // Armazena o tipo do arquivo selecionado
      let fileType = fileSelected.type;
      // Armazena os tipos de arquivos aceitos
      let acceptedTypes = ["application/pdf"];
      // Variável para armazenar o arquivo
      let file;
      // Variável que armazena a mensagem de erro
      let message = "Por favor, selecione um arquivo.";
      // Armazena o nome do arquivo
      let fileName = fileSelected.name;
      // Armazena as informações do input selecionado
      let inputFile;

      // Verifica se o arquivo selecionado é um PDF, caso não seja, retorna uma mensagem
      if (!acceptedTypes.includes(fileType)) {
        message =
          "Por favor, selecione um arquivo com formato válido (apenas PDF).";
        file = null;
        // Retira o arquivo do input
        event.target.value = "";
      } else {
        // Atribui o objeto do arquivo selecionado à variável file
        file = fileSelected;
      }

      // Verifica se o arquivo selecionado é maior que 20MB, caso seja, retorna uma mensagem de erro
      if (fileSelected.size > 20971520) {
        message = "Por favor, selecione um arquivo com tamanho máximo de 20MB.";
        file = null;

        // Retira o arquivo do input
        event.target.value = "";
      }

      // Atribui o valor da variável file ao input correspondente
      if (inputId === "arquivoRG") {
        this.form["doc_identidade"].value = file;
        inputFile = this.inputFiles["doc_identidade"];
      } else if (inputId === "arquivoCPF") {
        this.form["doc_cpf"].value = file;
        inputFile = this.inputFiles["doc_cpf"];
      } else if (inputId === "arquivoDiploma") {
        this.form["doc_diploma"].value = file;
        inputFile = this.inputFiles["doc_diploma"];
      } else if (inputId === "arquivoCertidaoCasamento") {
        this.form["doc_certidao_casamento"].value = file;
        inputFile = this.inputFiles["doc_certidao_casamento"];
      }

      inputFile.message = message;

      // Quando há erro o valor da variável file será null
      if (file == null) {
        inputFile.error = true;
        inputFile.fileName = "Nome do arquivo";
      } else {
        inputFile.error = false;
        inputFile.fileName = fileName;
      }
    },

    attCountiesPersonalData() {
      try {
        // Muda a lista de cidades dentro do input select com base no estado que foi selecionado
        this.countiesPersonalData =
          municipios[this.form["naturalidade_uf"].value].cidades;
      } catch (exception) {
        this.stateSelectedPersonalData = false;
        this.form["naturalidade_uf"].value = "";
      }

      // Habilita/desabilita o input select no qual as cidades serão selecionadas
      if (this.form["naturalidade_uf"].value === "") {
        this.stateSelectedPersonalData = false;
        this.form["naturalidade_municipio"].value = "";
      } else {
        this.stateSelectedPersonalData = true;
        this.form["naturalidade_municipio"].value = "";
      }
    },

    attCountiesAddress() {
      try {
        // Muda a lista de cidades dentro do input select com base no estado que foi selecionado
        this.countiesAddress =
          municipios[this.form["endereco_uf"].value].cidades;
      } catch (exception) {
        this.stateSelectedAddress = false;
        this.form["endereco_uf"].value = "";
      }

      // Habilita/desabilita o input select no qual as cidades serão selecionadas
      if (this.form["endereco_uf"].value === "") {
        this.stateSelectedAddress = false;
        this.form["municipio"].value = "";
      } else {
        this.stateSelectedAddress = true;
        this.form["municipio"].value = "";
      }
    },

    checkCompleted() {
      if (this.form.bindCPF.completed === true) {
        this.cpfValidated = this.validateCPF(this.form.bindCPF.unmasked);
      } else {
        this.cpfValidated = false;
      }
    },

    validateCPF(inputCPF) {
      // Fonte do código
      // https://pt.stackoverflow.com/questions/466400/validador-de-cpf-js-vue
      var soma = 0;
      var i;
      var resto;

      if (inputCPF == "00000000000") return false;
      for (i = 1; i <= 9; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(9, 10))) return false;

      soma = 0;
      for (i = 1; i <= 10; i++)
        soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(inputCPF.substring(10, 11))) return false;
      return true;
    },

    checkCompletedCEP() {
      // Verifica se a máscara do CEP tá completa
      if (this.form.bindCEP.completed == true) {
        // Usa a API para pegar os dados do CEP
        this.getDataForCEP(this.form.bindCEP.unmasked);
      } else {
        this.cepFound = false;
      }
    },

    async getDataForCEP(cep) {
      const response = await fetch(
        "https://viacep.com.br/ws/" + cep + "/json/"
      );
      const data = await response.json();
      if (data.erro == true || data.erro == "true") {
        this.cepFound = false;
        this.form["endereco"].value = "";
        this.form["bairro"].value = "";
        this.form["endereco_uf"].value = "";
        this.form["municipio"].value = "";
      } else {
        this.cepFound = true;
        this.form["cep"].value = cep;

        this.form["endereco"].found = !(data.logradouro === "");
        this.form["endereco"].value = data.logradouro;

        this.form["bairro"].found = !(data.bairro === "");
        this.form["bairro"].value = data.bairro;

        this.form["endereco_uf"].value = data.uf;
        // Busca a lista de cidades associadas ao estado
        this.countiesAddress =
          municipios[this.form["endereco_uf"].value].cidades;
        // Seleciona a cidade que foi retornada pela API
        this.form["municipio"].value = data.localidade;
      }
    },

    openModalForSearchCEP() {
      this.searchCEPMmodal.show();
    },

    acronymWithNameIES({ universidade, sigla, uf }) {
      // Une sigla com nome da universidade e sua respectiva UF para mostrar nas opções do select
      return `${sigla} — ${universidade} (${uf})`;
    },

    acronymWithNameIssBody({ sigla, extenso }) {
      // Une sigla com nome do órgão com seu nome por extenso para mostrar nas opções do select
      return `${sigla} — ${extenso}`;
    },

    lookForObjectIssBody(key) {
      for (let object in this.orgaos_emissores) {
        if (orgaos_emissores[object].extenso === key) {
          return orgaos_emissores[object];
        }
      }
    },

    lookForObjectUniversity(key) {
      for (let object in this.universidades) {
        if (universidades[object].universidade === key) {
          return universidades[object];
        }
      }
    },

    updateCountiesPersonalData(key) {
      for (let state in municipios) {
        if (state === key) {
          this.countiesPersonalData = municipios[state].cidades;
        }
      }
    },

    updateCountiesAddress(key) {
      for (let state in municipios) {
        if (state === key) {
          this.countiesAddress = municipios[state].cidades;
        }
      }
    },

    prevTab() {
      this.$refs.formWiz.prevTab();
    },

    nextTab() {
      this.$refs.formWiz.nextTab();
    },

    handleTabChange(index) {
      this.activeTabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables";

.validation-option {
  display: flex;
  justify-content: center;

  label {
    vertical-align: center;
    font-size: $text-md;
    margin-left: 5px;
  }
}

/* Mensagem de alerta dos campos órgao emissor e IES */

p.message-alert {
  font-size: 16px;
  font-weight: 500;
  color: #ca2323;
}

span.obs {
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  margin-bottom: 1em;

  p {
    word-break: break-word;
  }
}

p.card-text {
  font-size: 16px;
}

.inconsistent-background {
  background-color: rgba(255, 0, 0, 0.05);
}

/* ESTILIZAÇÃO DA NOTIFICAÇÃO */
.invalid-feedback {
  display: block;
  font-size: 20px;
}

.red {
  color: #ca2323 !important;
}

.form-control.is-invalid {
  border-color: #dc3545 !important;
}

/* NOTIFICAÇÃO DE INCONSISTÊNCIA */

.inconsistent-notification {
  font-size: 16px;
}

.inconsistent-notification span {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.inconsistent-notification span img {
  margin-right: 0.5rem;
}

.inconsistent-notification span p {
  margin: 0;
}

.inconsistent-items {
  margin: 1rem 0;
}

/* INPUT FILE */

input[type="file"] {
  cursor: pointer;
}

.input-file {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.label-file {
  display: flex;
}

.button-file {
  position: relative;
  width: 210px;
  border: hidden;
  border-radius: 10px 0 0 10px;
  color: #004a8a;
  cursor: pointer;
  font-weight: 700;
  background: #e0e0e0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
  padding: 1.15em 1em;
}

.button-file img {
  margin-right: 5px;
}

.field-submit-file {
  width: 75%;
  border: 1px solid #282828;
  border-radius: 0 10px 10px 0;
  background-color: #fff;
  color: #282828;
  cursor: pointer;
  padding: 1.15em 1.5em;
}

.field-submit-file.inconsistent-background {
  background-color: rgba(255, 0, 0, 0.05);
}

.input-file:disabled {
  cursor: default;
}

.field-submit-file:disabled {
  background-color: #e9ecef;
  color: #282828;
  cursor: default;
}

.field-submit-file.is-invalid {
  border-color: #dc3545;
}

/* ESTILIZAÇÃO DO BOTÃO */
.btn-default {
  width: 25em;
  padding: 1em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  font-size: 18px;
}

.btn-default:not([disabled]):hover {
  background-color: #5aad31;
  cursor: pointer;
}

.btn-default:disabled {
  background-color: #e0e0e0;
}

button.btn-search {
  padding: 1em 2em;
  border-radius: 0 10px 10px 0 !important;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  cursor: pointer;
}

button:hover {
  background-color: #5aad31;
}

.btn-search img {
  display: none;
}

button.btn-search:disabled {
  background-color: #e0e0e0;
}

/* ESTILIZAÇÃO DAS LABELS E INPUTS */

label.form-label {
  color: rgb(130, 130, 130);
  font-size: 18px;
}

input[type="text"],
input[type="date"],
select {
  border-radius: 10px;
  border-color: #282828;
  padding: 0.875em 1.5em;
}

/* ESTILIZAÇÃO DO RADIO + TEXT INPUT */

.group-input-check-text {
  display: flex;
  align-items: center;
}

.group-input-check-text input[type="radio"] {
  margin-right: 0.5em;
}

@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css");

.nav-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-around;

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    gap: 8px;
    width: 173px;
    height: 60px;
    background: #004a8a;
    border-radius: 10px;
    flex: none;
    order: 1;
    flex-grow: 0;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #ffffff;
  }
}

.wizard-footer-right,
.wizard-footer-left {
  .btn-wizard {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    gap: 8px;
    width: 173px;
    height: 60px;
    background: #004a8a;
    border-radius: 10px;
    flex: none;
    order: 1;
    flex-grow: 0;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #ffffff;
  }

  .btn-wizard:hover {
    background: #5aad31 !important;
    cursor: pointer;
  }
}

@media (max-width: 576px) {
  p.card-text {
    text-align: justify;
  }

  .card-body {
    padding: 0 !important;
  }

  div.row {
    flex-direction: column;
  }

  .wizard-card-footer {
    display: flex !important;
  }

  .wizard-footer-right,
  .wizard-footer-left {
    width: 100px;
  }

  .wizard-footer-right,
  .wizard-footer-left {
    .btn-wizard {
      width: 50% !important;
    }
  }

  .wizard-footer-right {
    .btn-wizard {
      float: right;
    }
  }

  //.vue-form-wizard .wizard-card-footer {
  //  padding: 0;
  //}

  .button-file span {
    display: none;
  }

  .button-file {
    width: 55px;
  }

  button.btn-search {
    width: 60px;
    padding: 0;
  }

  .btn-search span {
    display: none;
  }

  .btn-search img {
    display: block;
    margin: auto;
    width: 25px;
  }
}
</style>

<style>
/* Personalização do botão */

button.btn-default {
  width: 10em !important;
}

/* ESTILIZAÇÃO DO SELECT COM SEARCH */

.multiselect__tags {
  min-height: 40px;
  display: block;
  border-radius: 10px;
  border: 1px solid #282828;
  padding: 11.43px 40px 3.44px 25px;
  background: #fff;
  font-size: 16px;
  overflow: hidden;
  transition: all 0.5s;
}

.multiselect__option--highlight {
  background: #004a8a !important;
}

.multiselect__option--highlight:after {
  background: #004a8a !important;
}

.multiselect__single,
.multiselect__input {
  padding: 0 0 0 0;
  margin-top: 5px;
  margin-bottom: 12px;
}

.multiselect__select {
  top: 9px;
  background-color: transparent;
}

.multiselect__placeholder {
  white-space: nowrap;
  color: #212529;
}

.multiselect--disabled {
  background-color: white;
  opacity: 1;
}

.multiselect--disabled .multiselect__tags {
  background-color: #e9ecef;
  border-color: #282828;
  color: #212529;
  border-radius: 10px;
}

.multiselect__single {
  background-color: transparent;
}

.is-invalid .multiselect__tags {
  border-color: #dc3545;
}

.multiselect.inconsistent-background .multiselect__tags {
  background-color: rgba(255, 0, 0, 0.05);
}

.multiselect.inconsistent-background {
  background-color: transparent;
}
</style>
